import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ReactivateCustomerSubscription($customerId: ID!) {
    reactivateCustomerSubscription(customerId: $customerId) {
      status
    }
  }
`;

export const reactivateCustomerSubscription = (customerId) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
    },
  }).then(({ data }) => getSingleProp(data));
